export default __webpack_public_path__ + "static/media/Search.028dc3d2.svg";